import React, { useState } from 'react';
import authService from '../services/auth';

function LoginPage({ onAuthSuccess }) {
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) {
      setError('Password is required');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const isAuthenticated = await authService.authenticate(password);
      if (isAuthenticated) {
        onAuthSuccess();
      } else {
        setError('Invalid password. Please try again.');
      }
    } catch (error) {
      console.error('Authentication error:', error);
      setError('Authentication failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f5f5',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '10px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px'
      }}>
        <h1 style={{
          textAlign: 'center',
          marginBottom: '30px',
          color: '#333',
          fontSize: '24px'
        }}>
          Investor Q&A Assistant
        </h1>

        <p style={{
          textAlign: 'center',
          marginBottom: '30px',
          color: '#666',
          fontSize: '16px'
        }}>
          Please enter the password to access the application
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              disabled={isLoading}
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '16px',
                border: '2px solid #ddd',
                borderRadius: '5px',
                boxSizing: 'border-box',
                outline: 'none',
                transition: 'border-color 0.3s ease'
              }}
              onFocus={(e) => e.target.style.borderColor = '#007bff'}
              onBlur={(e) => e.target.style.borderColor = '#ddd'}
            />
          </div>

          {error && (
            <div style={{
              color: '#dc3545',
              fontSize: '14px',
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '16px',
              backgroundColor: isLoading ? '#ccc' : '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              transition: 'background-color 0.3s ease'
            }}
            onMouseOver={(e) => {
              if (!isLoading) e.target.style.backgroundColor = '#0056b3';
            }}
            onMouseOut={(e) => {
              if (!isLoading) e.target.style.backgroundColor = '#007bff';
            }}
          >
            {isLoading ? 'Authenticating...' : 'Login'}
          </button>
        </form>

        <footer style={{
          textAlign: 'center',
          marginTop: '30px',
          color: '#7f8c8d',
          fontSize: '14px'
        }}>
          <p>Powered by Claude AI</p>
        </footer>
      </div>
    </div>
  );
}

export default LoginPage;